// ============================================================================
//  decimal.ts — Conversion Prisma Decimal.js → number JavaScript
//  Prisma retourne les champs Decimal comme { s, e, d } (objet Decimal.js)
// ============================================================================

/**
 * Convertit un Decimal.js Prisma { s, e, d } ou un number/string en number JS
 * Algorithme Decimal.js : valeur = s * d[0] * 10^(e - len(str(d[0])) + 1)
 */
export const toNum = (v: any): number => {
  if (v === null || v === undefined) return 0
  if (typeof v === 'number') return v
  if (typeof v === 'string') return parseFloat(v) || 0
  if (typeof v === 'object' && Array.isArray(v.d) && typeof v.e === 'number' && v.d.length > 0) {
    try {
      const sign = v.s < 0 ? -1 : 1
      const d0   = v.d[0]
      const exp  = v.e - String(d0).length + 1
      return sign * d0 * Math.pow(10, exp)
    } catch { return 0 }
  }
  return Number(v) || 0
}

/** Formate en XOF (F CFA) */
export const fmtXOF = (n: any): string =>
  new Intl.NumberFormat('fr-SN', {
    style: 'currency',
    currency: 'XOF',
    minimumFractionDigits: 0,
  }).format(Math.round(toNum(n)))

/** Formate un nombre sans devise */
export const fmtNum = (n: any): string =>
  new Intl.NumberFormat('fr-SN', { minimumFractionDigits: 0 }).format(Math.round(toNum(n)))
